import { callAPI, HTTPMethod, getAuthenticatedGetUrl } from "./API";
import { Customers, Customer, CustomersQueryParams, CustomerRequest, CustomerImportSummaryResponse, CustomerExportResponse, CustomerUpdateClassificationsRequest, CustomerUpdateClassificationsResponse } from "../model/Customer";

const getBaseApi = (tenantId: string) => {
    return `/tenants/${tenantId}/customers`;
};

export async function getCustomers(tenantId: string, page: number, offset: number, params: CustomersQueryParams): Promise<Customers> {
    return await callAPI(getBaseApi(tenantId), {
        method: HTTPMethod.GET,
        query: {
            search: params.search,
            status: params.status || "",
            documentsStatus: params.documents_status || "",
            sortBy: params.sort_by || "",
            classification: params.classification || "",
            withSignin: params.with_signins === undefined ? "" : `${params.with_signins}`,
            pageSize: page.toString(),
            offset: offset.toString(),
        }
    });
}

export async function createCustomer(tenantId: string, request: CustomerRequest): Promise<Customer> {
    return await callAPI(getBaseApi(tenantId), {
        method: HTTPMethod.POST,
        body: request,
    });
}

export async function getCustomer(tenantId: string, customerId: string): Promise<Customer> {
    return await callAPI(`${getBaseApi(tenantId)}/${customerId}`, {
        method: HTTPMethod.GET,
    });
}

export async function updateCustomer(tenantId: string, customerId: string, request: CustomerRequest): Promise<Customer> {
    return await callAPI(`${getBaseApi(tenantId)}/${customerId}`, {
        method: HTTPMethod.PUT,
        body: request,
    });
}

export async function importCustomers(tenantId: string, file: File): Promise<CustomerImportSummaryResponse> {
    let data = new FormData();
    data.append("file", file as Blob, file.name);

    return await callAPI(`${getBaseApi(tenantId)}/import`, {
        method: HTTPMethod.POST,
        body: data,
        multipart: true
    });
}

export async function exportCustomers(tenantId: string, params: CustomersQueryParams): Promise<CustomerExportResponse> {
    return await callAPI(`${getBaseApi(tenantId)}/export`, {
        method: HTTPMethod.GET,
        query: {
            search: params.search,
            status: params.status || "",
            classification: params.classification || "",
            pageSize: "0",
            offset: "0",
        }
    });
}

export async function updateClassifications(tenantId: string, request: CustomerUpdateClassificationsRequest): Promise<CustomerUpdateClassificationsResponse> {
    return await callAPI(`${getBaseApi(tenantId)}/classifications`, {
        method: HTTPMethod.PATCH,
        body: request,
    });
}

export async function getCustomerPaymentReportUrl(tenantId: string, customerId: string): Promise<string> {
    return getAuthenticatedGetUrl(`${getBaseApi(tenantId)}/${customerId}/payments-report`);
}